import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchableSelect from "../../components/SearchableSelect";
import { addReward, fetchReward  ,setPageSize , clearCache } from "../../slices/TransactionHistorySlice/RewardSlice";
import { fetchPanelUser } from "../../slices/panelUserSlice";
import { fetchRewardType } from "../../slices/TransactionHistorySlice/RewardTypeSlice";
import { fetchSurveyStatus } from "../../slices/TransactionHistorySlice/SurveyStatusSlice";

const AddReward = () => {
  const dispatch = useDispatch(); 
  const panelUser = useSelector((state) => state.panelUser);
  const rewardType = useSelector((state) => state.rewardType);
  const surveyStatus = useSelector((state) => state.surveyStatus);

  const [formData, setFormData] = useState({
    pii: "",
    mode: "",
    surveyStatus: "",
    point: "",
    rewardId: "",
    title: "",
    detail: "",
    status:true
  });

  useEffect(() => {
    if (panelUser.status === "idle") {
    const resp =  dispatch(fetchPanelUser())
    console.log(resp)
    
    }

    if (rewardType.status === "idle") {
      dispatch(fetchRewardType())
    }

    if (surveyStatus.status === "idle") {
      dispatch(fetchSurveyStatus())
    }
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      pii: formData.pii,
      mode: formData.mode,
      surveyStatus: formData.surveyStatus,
      point: formData.point,
      rewardId: formData.rewardId,
      title: formData.title,
      detail: formData.detail,
      status:true
    };

    const resp = await dispatch(addReward(data));

    if (!resp.error) {
      setFormData({
        pii: "",
        mode: "",
        surveyStatus: "",
        point: "",
        rewardId: "",
        title: "",
        detail: "",
        status:true
      });
      dispatch(fetchReward());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4 max-w-md mx-auto">

      <select
        name="pii"
        value={formData.pii}
        onChange={handleChange}
        className="w-full p-1 border border-gray-400 rounded bg-white"
      >
        <option value="" hidden>Select PII</option>
        {panelUser?.panelUserList?.UserList?.map((user) => (
          <option key={user?.id} value={user?.pii}>{user?.email}</option>
        ))}
      </select>
      
      <SearchableSelect list={rewardType.rewardTypeList} formData={formData} handleChange={handleChange} name="mode" placeholder="Select Mode" />
      <SearchableSelect list={surveyStatus.surveyStatusList} formData={formData} handleChange={handleChange} name="surveyStatus" placeholder="Select Survey Status" />
      
      <input
        type="text"
        name="point"
        placeholder="Point"
        value={formData.point}
        onChange={handleChange}
        className="w-full p-1 border border-gray-400 rounded bg-white"
        required
      />
      
      <input
        type="text"
        name="rewardId"
        placeholder="Reward ID"
        value={formData.rewardId}
        onChange={handleChange}
        className="w-full p-1 border border-gray-400 rounded bg-white"
        required
      />
      
      <input
        type="text"
        name="title"
        placeholder="Title"
        value={formData.title}
        onChange={handleChange}
        className="w-full p-1 border border-gray-400 rounded bg-white"
        required
      />
      
      <input
        type="text"
        name="detail"
        placeholder="Detail"
        value={formData.detail}
        onChange={handleChange}
        className="w-full p-1 border border-gray-400 rounded bg-white"
        required
      />
      
      <button
        type="submit"
        className="w-full bg-[var(--mainCol)] text-white p-2 rounded"
      >
        Add POI
      </button>
    </form>
  );
};

export default AddReward;
